<template>
  <div
    class="position-relative"
    @mouseenter="scoreHovered = true"
    @mouseleave="scoreHovered = false"
  >
    <router-link
      class="d-flex justify-center align-center score-meter"
      :to="disableLink ? '' : { name: 'editor-view', params: { id } }"
      @click.stop
    >
      <LanguageBadge
        v-if="isNonEnglish"
        :language-code="languageCode"
      />
      <ScoreMeter
        v-else
        :score="score"
        icon
        animate
      />
    </router-link>
    <v-icon
      v-if="scoreHovered && !disableLink"
      size="16"
      class="hover-icon"
      icon="material-symbols-light:edit-square-outline"
    />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import ScoreMeter from '@/components/editor/ScoreMeter.vue';
import LanguageBadge from '@/components/shared/LanguageBadge.vue';
import { isNonEnglishCode } from '@/helpers/language';

const props = defineProps({
  score: { type: [Number, String], default: null },
  id: { type: [String, Number], required: true },
  disableLink: { type: Boolean, default: false },
  languageCode: { type: String, default: null },
});
const scoreHovered = ref(false);
const isNonEnglish = computed(() => isNonEnglishCode(props.languageCode));
</script>

<style lang="less" scoped>
.hover-icon {
  position: absolute;
  bottom: -2px;
  right: -12px;
  color: fade(@grey-900, 75%);
}

.score-meter {
  width: 40px;
  height: 40px;
}
</style>
